import { OrganisationProfileType } from '@finxone-platform/shared/sys-config-types';
import { PageConfig } from '../../../../zones/mobile/default-zone-page-setups';

export const defaultOrganisationProfilePages: PageConfig[] = [
  {
    name: 'Profile Landing Page',
    title: 'Profile Landing Page',
    tags: [OrganisationProfileType.ORGANISATION_PROFILE],
    url: 'organisation-profile-landing',
    widgets: [],
  },
];
